import React, { createContext } from 'react'
import styles from './styles-context.module.scss'
import BupSpinner from '@BUP/components/Loading/Spinner'
import { useGetCurrentTerm } from '@BUP/hooks/Terms/useGetCurrentTerm'
import ErrorMessage from '@BUP/components/Error/Message'
import { useTranslation } from 'react-i18next'

export const CurrentTermContext = createContext()

export const CurrentTermContextProvider = ({ children }) => {
  const i18n = useTranslation()

  const { data: term, isLoading, isError } = useGetCurrentTerm()

  if (isLoading) {
    return (
      <div className={styles.loading_current_term_wrapper}>
        <BupSpinner size='large' />
      </div>
    )
  }
  if (isError || !term) {
    return (
      <div className={styles.error_wrapper}>
        <ErrorMessage
          message={i18n.t('common.resources.term.actions.read.failure', { context: 'current' })}
        />
      </div>
    )
  }

  return (
    <CurrentTermContext.Provider value={term}>
      {children}
    </CurrentTermContext.Provider>
  )
}
